import { render, staticRenderFns } from "./dddl.vue?vue&type=template&id=1044f2ce&scoped=true&"
import script from "./dddl.vue?vue&type=script&lang=js&"
export * from "./dddl.vue?vue&type=script&lang=js&"
import style0 from "./dddl.vue?vue&type=style&index=0&id=1044f2ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044f2ce",
  null
  
)

export default component.exports